import { render, staticRenderFns } from "./anQuan.vue?vue&type=template&id=822981a4&scoped=true"
import script from "./anQuan.vue?vue&type=script&lang=js"
export * from "./anQuan.vue?vue&type=script&lang=js"
import style0 from "./anQuan.vue?vue&type=style&index=0&id=822981a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822981a4",
  null
  
)

export default component.exports